<template>
    <cart-template v-if="!isPaid" :canBack="false">
        <template #configuration>
            <el-form ref="clientCartForm" labelPosition="top" :rules="rules" :model="modelForm">
                <public-payment-cart></public-payment-cart>
            </el-form>
        </template>
        <!-- Summary -->
        <template #resume>
            <cart-summary context="client">
                <template #licences>
                    <ul class="cart-licences-list mb-0 mx-0">
                        <li
                            v-for="product in productsWithLicences"
                            :key="product.code"
                            class="flex-row"
                        >
                            <div>
                                <p class="grey mb-0 mt-0 fs-3">
                                    {{
                                        $l10n.n__(
                                            '%(total)s licence %(productsName)s',
                                            '%(total)s licences %(productsName)s',
                                            products[product.id].quantity,
                                            {
                                                total: products[product.id].quantity,
                                                productsName: product.title,
                                            },
                                        )
                                    }}
                                </p>
                                <span
                                    v-if="freeLicencesByProduct(product.id)"
                                    class="grey mt-1 block"
                                    >{{
                                        $l10n.n__(
                                            'Dont %s offerte',
                                            'Dont %s offertes',
                                            freeLicencesByProduct(product.id),
                                            freeLicencesByProduct(product.id),
                                        )
                                    }}</span
                                >
                            </div>
                            <template v-if="products[product.id].total">
                                <p
                                    v-if="freeLicencesByProduct(product.id)"
                                    class="flex-item-right my-0"
                                >
                                    <span class="strike grey">{{
                                        $filters.numberFormatToFloatWithOptions(
                                            products[product.id].total.monthly.total_amount,
                                            numformat,
                                            true,
                                        )
                                    }}</span>
                                    <span class="success-50 fs-3 pl-2 semibold"
                                        >{{
                                            $filters.numberFormatToFloatWithOptions(
                                                products[product.id].total.monthly
                                                    .total_amount_discounted,
                                                numformat,
                                                true,
                                            )
                                        }}{{ $l10n.__('/mois') }}</span
                                    >
                                </p>
                                <p v-else class="flex-item-right my-0 fs-3 semibold grey">
                                    {{
                                        $filters.numberFormatToFloatWithOptions(
                                            products[product.id].total.monthly
                                                .total_amount_discounted,
                                            numformat,
                                            true,
                                        )
                                    }}{{ $l10n.__('/mois') }}
                                </p>
                            </template>
                        </li>
                        <!-- Packs Summary -->
                        <li
                            v-for="product in packsWithLicences"
                            :key="product.code"
                            class="flex-row"
                        >
                            <div>
                                <p class="grey mb-1 mt-0 fs-3">
                                    {{
                                        $l10n.__('Module %(productsName)s', {
                                            productsName: product.title,
                                        })
                                    }}
                                </p>
                            </div>
                            <template v-if="products[product.id].total">
                                <!-- Discount detail -->
                                <p
                                    v-if="
                                        products[product.id].total.monthly.total_amount_discounted <
                                        products[product.id].total.monthly.total_amount
                                    "
                                    class="flex-item-right my-0 semibold"
                                >
                                    <span class="strike grey">{{
                                        $filters.numberFormatToFloatWithOptions(
                                            products[product.id].total.monthly.total_amount,
                                            numformat,
                                            true,
                                        )
                                    }}</span>
                                    <span class="success-50 fs-3 pl-2">
                                        <template
                                            v-if="
                                                products[product.id].total.monthly
                                                    .total_amount_discounted !== 0
                                            "
                                        >
                                            {{
                                                $filters.numberFormatToFloatWithOptions(
                                                    products[product.id].total.monthly
                                                        .total_amount_discounted,
                                                    numformat,
                                                    true,
                                                )
                                            }}{{ $l10n.__('/mois') }}
                                        </template>
                                        <template v-else>{{ $l10n.__('Offert') }}</template>
                                    </span>
                                </p>
                                <!-- Base price -->
                                <p v-else class="flex-item-right my-0 fs-3 semibold grey">
                                    {{
                                        $filters.numberFormatToFloatWithOptions(
                                            products[product.id].total.monthly
                                                .total_amount_discounted,
                                            numformat,
                                            true,
                                        )
                                    }}{{ $l10n.__('/mois') }}
                                </p>
                            </template>
                        </li>
                    </ul>
                </template>
                <template #subtotal>
                    <div class="flex-column fs-3 cart-recap-total-label">
                        <span class="mb-3">{{ $l10n.__('Sous-total') }}</span>
                        <span v-if="taxRate && taxRate !== 0" class="mb-3"
                            >{{ $l10n.__('TVA') }} {{ taxRate }}%</span
                        >
                    </div>
                    <div v-if="isYearly" class="flex-column aright fs-3">
                        <span class="semibold mb-3"
                            >{{
                                $filters.numberFormatToFloatWithOptions(
                                    totalYearly.total_amount_discounted,
                                    numformat,
                                    true,
                                )
                            }}{{ $l10n.__('/an') }}</span
                        >
                        <span v-if="taxRate && taxRate !== 0" class="semibold mb-3">
                            {{
                                $filters.numberFormatToFloatWithOptions(
                                    totalYearly.total_amount_vat,
                                    numformat,
                                    true,
                                )
                            }}
                        </span>
                    </div>
                    <div v-if="isMonthly" class="flex-column aright fs-3">
                        <span class="semibold mb-3"
                            >{{
                                $filters.numberFormatToFloatWithOptions(
                                    totalMonthly.total_amount_discounted,
                                    numformat,
                                    true,
                                )
                            }}{{ $l10n.__('/mois') }}</span
                        >
                        <span v-if="taxRate && taxRate !== 0" class="semibold mb-3">
                            {{
                                $filters.numberFormatToFloatWithOptions(
                                    totalMonthly.total_amount_vat,
                                    numformat,
                                    true,
                                )
                            }}
                        </span>
                    </div>
                </template>
                <template #total>
                    <div class="flex-row jc-space">
                        <p class="fs-4 my-0 bold cart-recap-total-label">
                            {{ $l10n.__('Total TTC') }}
                        </p>
                        <p v-if="isYearly" class="fs-4 my-0 aright bold flex-row baseline">
                            {{
                                $filters.numberFormatToFloatWithOptions(
                                    totalYearly.total_amount_tax_included,
                                    numformat,
                                    true,
                                )
                            }}
                            <span class="fs-2">{{ $l10n.__('/an') }}</span>
                        </p>
                        <p v-if="isMonthly" class="fs-4 my-0 aright bold flex-row baseline">
                            {{
                                $filters.numberFormatToFloatWithOptions(
                                    totalMonthly.total_amount_tax_included,
                                    numformat,
                                    true,
                                )
                            }}
                            <span class="fs-2">{{ $l10n.__('/mois') }}</span>
                        </p>
                    </div>
                </template>
                <template #actions>
                    <CompassButton
                        :label="labelButton"
                        type="primary"
                        leftIcon="lock-fill"
                        :loading="computeLoading"
                        class="wp-10 mt-4"
                        @click="submitForm('clientCartForm', 'create')"
                    />
                </template>
            </cart-summary>
        </template>
    </cart-template>
    <payment-confirmed v-else :isConnected="false"></payment-confirmed>
</template>

<script>
import PricingV4Module from 'stores/sellsyaccountmanager/v4/public';
import CartTemplate from 'vcomponents/pages/account/CartTemplate.vue';
import CartSummary from 'vcomponents/pages/account/CartSummary.vue';
import PublicPaymentCart from 'vcomponents/pages/account/public/PublicPaymentCart.vue';
import { createNamespacedHelpers } from 'vuex';
import { checkIsTrue } from 'vcomponents/forms/rules/Rules';
import FormMixin from 'mixins/FormMixins';
import PaymentConfirmed from 'vcomponents/pages/subscription/PaymentConfirmed.vue';
import PlansData from 'Config/authenticated/PlansData';

const clientCart = createNamespacedHelpers('clientCart');

export default {
    mixins: [FormMixin],
    props: {
        customer: {
            type: Object,
            required: true,
        },
        cart: {
            type: Object,
            required: true,
        },
        productsList: {
            type: Array,
            required: true,
        },
        billingLocales: {
            type: Object,
            required: true,
        },
        computeCart: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            rules: {
                cardNumber: [
                    {
                        validator: checkIsTrue,
                        message: this.$l10n.__('Veuillez renseigner un numéro de carte valide'),
                    },
                ],
                cardExpiry: [
                    {
                        validator: checkIsTrue,
                        message: this.$l10n.__('Veuillez renseigner une date valide'),
                    },
                ],
                cardCvc: [
                    {
                        validator: checkIsTrue,
                        message: this.$l10n.__('Veuillez renseigner un code valide'),
                    },
                ],
                cardName: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez renseigner le nom sur la carte'),
                    },
                ],
            },
            isPaid: false,
        };
    },
    computed: {
        ...clientCart.mapGetters([
            'products',
            'productsWithLicences',
            'packsWithLicences',
            'freeLicencesByProduct',
            'taxRate',
            'isYearly',
            'isMonthly',
            'totalMonthly',
            'totalYearly',
            'numformat',
            'computeLoading',
            'modelForm',
            'cartId',
            'isManualMethod',
        ]),
        labelButton() {
            return this.isManualMethod
                ? this.$l10n.__('Confirmer le virement')
                : this.$l10n.__('Valider le paiement');
        },
    },
    created() {
        this.$store.registerModule('clientCart', PricingV4Module);
        this.setCustomerId(this.customer.id);
        this.setCartId(this.cart.id);
        this.setCorporationId(this.customer.saasCorpId);
        this.setCorpName(this.customer.name);
        this.setPlan(this.cart.pricingPlanId);
        this.setUserContext('pay');
        this.setVatIntra(this.customer.billingSettings.vatIdentificationNumber);
        this.setTaxRate(this.computeCart.tax_rate);
        this.setCartTotal({ monthly: this.computeCart.monthly, yearly: this.computeCart.yearly });

        const cartProducts = {};
        this.cart.items.forEach(
            (item) =>
                (cartProducts[item.product] = {
                    quantity: item.quantity,
                    customPricing: item.customPricing,
                    total: {
                        monthly: {
                            total_amount:
                                item.totalAmountPerMonth + item.totalDiscountAmountPerMonth,
                            total_amount_discount: item.totalDiscountAmountPerMonth,
                            total_amount_discounted: item.totalAmountPerMonth,
                            total_tax_included: null,
                            total_amount_vat: null,
                        },
                        yearly: {
                            total_amount: item.totalAmountPerYear + item.totalDiscountAmountPerYear,
                            total_amount_discount: item.totalDiscountAmountPerYear,
                            total_amount_discounted: item.totalAmountPerYear,
                            total_tax_included: null,
                            total_amount_vat: null,
                        },
                    },
                }),
        );

        this.setMetadata({
            billingSettings: {
                ...this.customer.billingSettings,
                contactFirstname: this.customer.billingSettings.contactFirstName,
            },
            billingAddress: this.customer.billingAddress,
            billingLocales: _.map(this.billingLocales, (locale) => {
                return { code: locale.id.toUpperCase(), name: locale.label };
            }),
            products: this.productsList,
            cart: {},
            plans: _.map(PlansData, ({ code, title }) => {
                return { code, name: title };
            }),
        });
        this.setCart({
            ...this.cart,
            products: cartProducts,
            plan: this.cart.pricingPlanId,
            activationDate: this.cart.periodApplianceStart,
        });
        EventBus.on('stripe:public:paid', () => {
            document.body.classList.add('page-sam-v4-selfservice-cart-checkout-paid');
            this.isPaid = true;
        });
    },
    unmounted() {
        EventBus.off('stripe:public:paid');
    },
    methods: {
        ...clientCart.mapMutations([
            'setCustomerId',
            'setCartId',
            'setPlan',
            'setCorporationId',
            'setComputeLoading',
            'setCartTotal',
            'setUserContext',
            'setVatIntra',
            'setCorpName',
            'setTaxRate',
        ]),
        ...clientCart.mapActions(['setCart', 'setMetadata']),
        async create() {
            try {
                if (this.isManualMethod) return (this.isPaid = true);
                EventBus.emit('stripe:public');
            } catch (err) {
                this.setComputeLoading(false);
                Push.error(
                    this.$l10n.__('Une erreur est survenue, veuillez ré-essayer ultérieurement.'),
                );
            }
        },
    },
    components: {
        CartTemplate,
        CartSummary,
        PublicPaymentCart,
        PaymentConfirmed,
    },
};
</script>
<style lang="scss" scoped>
.cart {
    margin: 0;
}

.cart-licences-list {
    li {
        margin-bottom: 8px;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>

<style lang="scss">
.page-sam-v4-selfservice-cart-checkout {
    padding: 0;
}
</style>
